/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Imm from '../../support/ImmutableHelpers';
import { createHexId } from '../../support/createHexId';
import { OptionValue } from '../../types/FormBuilder/FormElements';

import { FormFieldDefinition } from '../../types/shared/FormFieldDefinition';

const defaultDefinition = {
  id: '',
  type: '',
  name: '',
  label: '',
  hidden: false,
  is_required: false,
  is_public: false,
};

const defaultAttributes = {};

type Definition = {
  id: string;
  type: string;
  [key: string]: unknown;
};

class FormElementBase {
  id: string;
  type: string;
  formID: string;
  definition: Definition = defaultDefinition;

  static getType() {
    return '';
  }

  static getDescription() {
    return '';
  }

  static getAttributes() {
    return defaultAttributes;
  }

  constructor(
    formID: string,
    definition?: FormFieldDefinition | null | undefined,
  ) {
    this.formID = formID;
    if (definition) {
      this.definition = { ...definition };
    } else {
      let FormElement = this.constructor as typeof FormElementBase;
      let type = FormElement.getType();
      let attributes = FormElement.getAttributes();

      this.definition = {
        ...defaultDefinition,
        id: createHexId(),
        type,
        ...attributes,
      };
    }
    // Allows this to be part of an IndexedList
    this.id = this.definition.id;
    this.type = this.definition.type;
  }

  isRequired() {
    let { definition } = this;
    return definition.hidden !== true && definition.is_required === true;
  }

  update(updates: { [key: string]: any }) {
    let oldDefinition = this.toJSON();
    let newDefinition = Imm.setProperties(oldDefinition, updates);
    if (newDefinition === oldDefinition) {
      return this;
    }
    let FormElement = this.constructor as typeof FormElementBase;
    return new FormElement(this.formID, newDefinition as any);
  }

  renderFormView(): ReactElement | null | undefined {
    return null;
  }

  renderReadOnlyView(_props: any): ReactElement | null | undefined {
    return null;
  }

  renderEditView(_props: any): ReactElement | null | undefined {
    return null;
  }

  getValueAsOptions(): Array<OptionValue> {
    return [];
  }

  toJSON() {
    let definition = this.definition;
    let FormElement = this.constructor as typeof FormElementBase;
    let result: Definition = {
      id: definition.id,
      type: FormElement.getType(),
    };
    let attributes = FormElement.getAttributes();
    for (let key of Object.keys(attributes)) {
      if (key in definition) {
        result[key] = definition[key];
      }
    }
    return result;
  }
}

export default FormElementBase;
